import type { Middleware } from 'redux';

import { getErrorDebugLogsState, reducer, setErrorDebugLogsState } from './state';

export const errorDebugLogsMiddleware: Middleware = () => (next) => (action) => {
  setErrorDebugLogsState(reducer(getErrorDebugLogsState(), action));

  return next(action);
};
